// Special-order panel. Keeps the part-number field in step with the search box until the buyer
// edits it, and lets "Request" links on caliber cards (snippets/caliber-card.liquid) prefill
// the form, open it and move focus to it.

class SSpecialOrder extends HTMLElement {
  #ac;
  #partDirty = false;
  #timer = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.details = this.querySelector('[data-form-details]');
    this.part = this.querySelector('[data-field-part]');
    this.type = this.querySelector('[data-field-type]');
    this.brand = this.querySelector('[data-field-brand]');

    this.part?.addEventListener('input', () => { this.#partDirty = true; }, { signal });
    this.querySelectorAll('[data-open-form]').forEach((a) =>
      a.addEventListener('click', (e) => { e.preventDefault(); this.openForm(); }, { signal })
    );

    // Request links live in the live-search results, which re-render, so listen on the document.
    document.addEventListener('click', (e) => {
      const link = e.target.closest?.('[data-so-fill]');
      if (!link) return;
      e.preventDefault();
      this.openForm({ part: link.dataset.soPart, type: link.dataset.soType, brand: link.dataset.soBrand });
    }, { signal });

    if (this.dataset.mode === 'search') {
      const q = document.querySelector('form[action*="search"] input[name="q"]');
      q?.addEventListener('input', () => {
        clearTimeout(this.#timer);
        this.#timer = setTimeout(() => {
          if (!this.#partDirty && this.part) this.part.value = q.value.trim();
        }, 300);
      }, { signal });
    }

    if (location.search.includes('contact_posted=true')) this.scrollIntoView({ block: 'start' });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
  }

  openForm(fields = {}) {
    if (fields.part && this.part) { this.part.value = fields.part; this.#partDirty = true; }
    if (fields.type && this.type) this.type.value = fields.type;
    if (fields.brand && this.brand) this.brand.value = fields.brand;
    if (this.details) this.details.open = true;
    this.details?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => this.querySelector('#so-name')?.focus({ preventScroll: true }), 400);
  }
}

if (!customElements.get('s-special-order')) customElements.define('s-special-order', SSpecialOrder);
